<template>
  <v-container fluid>
    <v-row class="fill-height">
      <v-col md="12">
        <h2 class="mb-3 primary--text">{{$t('calendar_welcome')}}</h2>
        <h5 class="grey--text">
         {{$t('calendar_description')}}
        </h5>
        <v-dialog v-model="addEvent" max-width="700px">
          <template v-slot:activator="{ on }">
            <v-btn
              class="mt-3"
              color="primary"
              v-on="on"
              dark
              medium
              @click="addedItem()"
            >
              <v-icon medium>mdi-plus</v-icon>{{$t('calendar_add')}}
            </v-btn>
          </template>
          <v-form v-model="valid">
            <v-card class="pt-3">
              <v-card-title>
                <span class="headline ml-2">{{$t('calendar_add')}}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col md="6">
                      <v-menu
                        ref="menu_start"
                        v-model="menu_start"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="dateStartFormatted"
                            :label="$t('start_date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                            color="primary"
                            :rules="rules"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date_start"
                          @change="onStartDateChange()"
                          no-title
                          :locale="$t('locale')"
                          scrollable
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col md="6">
                      <v-menu
                        ref="menu_end"
                        v-model="menu_end"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="dateEndFormatted"
                            :label="$t('end_date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                            color="primary"
                            :rules="rules"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date_end"
                          @change="onEndDateChange()"
                          no-title
                          scrollable
                          :locale="$t('locale')"
                          :min="date_start"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-form v-model="valid" ref="addForm">
                    <v-row>
                      <v-col md="12">
                        <v-select
                          :items="holiday_category"
                          :label="$t('calendar_category')"
                          v-model="addItem.category"
                          item-text="name"
                          item-value="id"
                          :rules="rules"
                          required
                        ></v-select>
                      </v-col>
                      <v-col md="12">
                        <v-text-field
                         :label="$t('calendar_name')"
                          v-model="addItem.description"
                          :rules="[...rules2nd, validator.alfaNumberNotRequired]"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions class="mx-6 pb-6">
                <v-row justify="center">
                  <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!valid"
                    :loading="loading"
                    @click="postEvents(editedItem)"
                    >{{$t('save')}}</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-col>
      <v-col md="12">
        <v-sheet height="64">
          <v-toolbar flat color="white">
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"
              >{{$t('calendar_today')}}</v-btn
            >
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ getMonth($refs.calendar.value) }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>{{$t('day')}}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>{{$t('week')}}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>{{$t('month')}}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            :locale="$t('locale')"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
          >
            <template v-slot:top></template>
          </v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-dialog v-model="editDialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="editItem(selectedEvent)" icon>
                      <v-icon medium>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="pt-3">
                    <v-card-title>
                      <span class="headline ml-2">Edit Holidays</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col md="6">
                            <v-menu
                              ref="menu_start"
                              v-model="menu_start_edit"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="dateStartFormattedEdit"
                                  :label="$t('start_date')"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-on="on"
                                  color="primary"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="editedItem.start"
                                @change="onStartDateChange()"
                                no-title
                                scrollable
                                :locale="$t('locale')"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col md="6">
                            <v-menu
                              ref="menu_end"
                              v-model="menu_end_edit"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="dateEndFormattedEdit"
                                  :label="$t('start_date')"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-on="on"
                                  color="primary"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="editedItem.end"
                                @change="onEndDateChange()"
                                no-title
                                scrollable
                                :locale="$t('locale')"
                                :min="editedItem.start"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col md="12">
                            <v-select
                              :items="holiday_category"
                             :label="$t('calendar_type')"
                              v-model="editedItem.details"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </v-col>
                          <v-col md="12">
                            <v-text-field
                             :label="$t('calendar_name')"
                              v-model="editedItem.name"
                              :rules="[...rules2nd, validator.alfaNumberNotRequired]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="mx-6 pb-6">
                      <v-row justify="center">
                        <v-btn color="primary" text @click="close"
                          >{{$t('cancel')}}</v-btn
                        >
                        <v-btn
                          color="primary"
                          dark
                          @click="EditEvents(editedItem)"
                          :loading="loading"
                          >{{$t('save')}}</v-btn
                        >
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="deleteDialog" persistent max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="deleteItem()" icon>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline"
                      >{{$t('calendar_delete')}}</v-card-title
                    >
                    <v-card-text
                      >{{$t('you_sure')}}</v-card-text
                    >
                    <v-card-actions class="pa-3">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="deleteDialog = false"
                        >{{$t('cancel')}}</v-btn
                      >
                      <v-btn
                        color="error"
                        @click="deleteEvents(selectedEvent.id)"
                        :loading="loading"
                        >{{$t('delete')}}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-card-text>
                <span v-if="selectedEvent.details == 0">
                  {{$t('calendar_national')}}
                </span>
                <span v-else-if="selectedEvent.details == 1">
                  {{$t('calendar_corporate')}}
                </span>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="primary" @click="selectedOpen = false"
                  >{{$t('cancel')}}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  name: "calendar",
  data() {
    return {
      disableEndDate: true,
      today: new Date().toISOString().substr(0, 10),
      focus: new Date().toISOString().substr(0, 10),
      type: "month",
      typeToLabel: {
        month: this.$i18n.t('month'),
        week: this.$i18n.t('week'),
        day: this.$i18n.t('day')
      },
      description: null,
      category: null,
      date: new Date().toISOString().substr(0, 10),
      date_unix: {},
      date_start: null,
      date_end: null,
      menu_start: false,
      menu_end: false,
      menu_start_edit: false,
      menu_end_edit: false,
      colors: "orange",
      currentlyEditing: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      dialog: false,
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      addEvent: false,
      editDialog: false,
      deleteDialog: false,
      addItem: {
        dateStart: "",
        dateEnd: "",
        description: "",
        category: "",
        companyId: "",
      },
      editedItem: {
        dateStart: "",
        dateEnd: "",
        description: "",
        category: "",
        id: "",
      },
      itemToDelete: {
        id: "",
        description: "",
        companyId: "",
      },
      holiday_category: [
        {
          name: this.$i18n.t('calendar_national'),
          id: 0,
        },
        {
          name: this.$i18n.t('calendar_corporate'),
          id: 1,
        },
      ],
      editedIndex: -1,
      calendar: [
        {
          id: "",
          description: "",
          companyId: "",
        },
      ],
      valid: true,
      rules: [(value) => (value == 0 ? true : !!value || this.$i18n.t('required'))],
      rules2nd: [(v) => !!v || this.$i18n.t('required')],
      loading: false,
    };
  },
  mounted() {
    this.getEvents();
  },
  computed: {
    dateStartFormatted() {
      return this.date_start
        ? moment(this.date_start, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("dddd, MMMM Do YYYY")
        : "";
    },
    dateEndFormatted() {
      return this.date_end
        ? moment(this.date_end, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("dddd, MMMM Do YYYY")
        : "";
    },
    dateStartFormattedEdit() {
      return this.editedItem.start
        ? moment(this.editedItem.start, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format(
            "dddd, MMMM Do YYYY"
          )
        : "";
    },
    dateEndFormattedEdit() {
      return this.editedItem.end
        ? moment(this.editedItem.end, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("dddd, MMMM Do YYYY")
        : "";
    },
  },
  methods: {
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    getMonth(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("MMMM YYYY");
    },
    onStartDateChange() {
      this.menu_start = false;
      this.menu_start_edit = false;
      this.disableEndDate = false;
      this.date_unix.start = Number(moment(this.date_start).locale(this.$i18n.t('lang')).format("x"));
      this.date_end = this.date_start;
    },
    onEndDateChange() {
      this.menu_end = false;
      this.menu_end_edit = false;
      this.date_unix.end = Number(
        moment(this.date_end).locale(this.$i18n.t('lang'))
          .add(1, "d")
          .subtract(1, "s")
          .format("x")
      );
    },
    getEventColor(event) {
      return event.color;
    },
    addedItem() {
      this.addEvent = true;
    },
    editItem(item) {
      this.editedIndex = this.events.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
      this.getEvents();
    },
    deleteItem(item) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteDialog = true;
    },
    close() {
      this.dialog = false;
      this.addEvent = false;
      this.editDialog = false;
      this.deleteDialog = false;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    setToday() {
      this.focus = moment().locale(this.$i18n.t('lang')).format("YYYY-MM-DD");
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    async getEvents() {
      const result = await this.$store.dispatch('getCalendarHoliday', {companyId: this.company_id})
      const event = [];
      result.map((item) => {
        event.push({
          name: item.description,
          start: item.date_start,
          end: item.date_end,
          timed: 1,
          color: item.category ? "warning" : "success",
          id: item.id,
          details: item.category,
        });
      });
      this.events = event;
    },
    async postEvents() {
      let body = {
        dateStart: moment(this.date_start, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("DD-MM-YYYY"),
        dateEnd: moment(this.date_end, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("DD-MM-YYYY"),
        category: this.addItem.category,
        description: this.addItem.description,
        companyId: this.company_id,
      };
      if (this.date_end < this.date_start) {
        this.showMessage('warning', 'Date End Should be more than Date Start')
        this.addEvent = true;
      } else {
        this.loading = true;
        const result = await this.$store.dispatch('saveCalendarHoliday', body)
        this.loading = false;
        if (result) {
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.getEvents();
        }
        this.addEvent = false;
      }
    },
    compareDate(start, end) {
      const a = moment(start, 'YYYY-MM-DD').locale(this.$i18n.t('lang')).format('x')
      const b = moment(end, 'YYYY-MM-DD').locale(this.$i18n.t('lang')).format('x')

      if (a >= b) { return false } else { return true }
    },
    async EditEvents(item) {
      let body = {
        dateStart: moment(item.start, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("DD-MM-YYYY"),
        dateEnd: moment(item.end, "YYYY-MM-DD").locale(this.$i18n.t('lang')).format("DD-MM-YYYY"),
        category: item.details,
        description: item.name,
        id: item.id,
      };
      if (this.editedItem.end < this.editedItem.start) {
        this.loading = false;
        this.showMessage('warning', 'Date End Should be more than Date Start')
      } else {
        this.loading = true
        const result = await this.$store.dispatch('editCalendarEdit', body)
        this.loading = false
        if (result) {
          this.editDialog = false;
          this.selectedOpen = false;
          this.showMessage('success', 'Data Successfully Edited')
          this.getEvents();
        }
      }
    },
    async deleteEvents(id) {
      this.loading = true
      const result = await this.$store.dispatch('deleteCalendarHoliday', { id })
      this.loading = false
      if (result) {
        this.deleteDialog = false;
        this.selectedOpen = false;
        this.showMessage('success', this.$i18n.t('save'))
        this.getEvents();
      }
    },
  },
  created() {
    this.date_start = moment(this.date).locale(this.$i18n.t('lang')).format("YYYY-MM-DD");
    this.date_end = moment(this.date).locale(this.$i18n.t('lang')).format("YYYY-MM-DD");
    this.date_unix = {
      start: Number(moment(this.date_start).locale(this.$i18n.t('lang')).format("x")),
      end: Number(
        moment(this.date_end).locale(this.$i18n.t('lang'))
          .add(1, "d")
          .subtract(1, "s")
          .format("x")
      ),
    };
    this.getEvents();
  },
  watch: {
    addEvent() {
      if (this.$refs.addForm) {
        this.$refs.addForm.reset();
        this.disableEndDate = true;
      }
    },
  },
};
</script>
